export default __webpack_public_path__ + "c4ddfb20528ef6f649465ed26f0fd24d.png";